// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
require('swiper/dist/css/swiper.css')

import Vue from 'vue';
import App from './App';
import router from './router';
import {store} from './store';
import Vuebar from 'vuebar';
import VueYoutube from 'vue-youtube'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import { VueHammer } from 'vue2-hammer'
import "./assets/scss/app.scss";

Vue.config.productionTip = false;
Vue.use(Vuebar);
Vue.use(VueYoutube);
Vue.use(VueAwesomeSwiper);
Vue.use(VueHammer);


let initialize = () => {
    new Vue({
        el: '#app',
        store,
        router,
        template: '<App/>',
        created() {
            window.vue = this;
        },
        components: {App}
    });
};

store.dispatch('getUser').then(
    () => {
        initialize();
    },
    () => {
        initialize();
    }
);

store.dispatch('getCurrentWeek');




// WEBPACK FOOTER //
// ./src/main.js